/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DonutChartBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g><path d="M11 3.62a.524.524 0 0 1-.437.509A8.002 8.002 0 0 0 4.47 14.704a.523.523 0 0 1-.222.633l-.883.51a.48.48 0 0 1-.691-.233A9.975 9.975 0 0 1 2 12c0-4.996 3.664-9.137 8.452-9.88A.48.48 0 0 1 11 2.6v1.02ZM19.758 15.324a.523.523 0 0 1-.222-.631 8.002 8.002 0 0 0-6.099-10.564A.524.524 0 0 1 13 3.62V2.601a.48.48 0 0 1 .548-.482C18.336 2.863 22 7.004 22 12c0 1.27-.236 2.483-.668 3.6a.48.48 0 0 1-.691.234l-.883-.51ZM18.756 17.055a.523.523 0 0 0-.658.123A7.982 7.982 0 0 1 12 20a7.982 7.982 0 0 1-6.09-2.812.523.523 0 0 0-.657-.123l-.883.51a.48.48 0 0 0-.143.717A9.98 9.98 0 0 0 12 22a9.98 9.98 0 0 0 7.782-3.719.48.48 0 0 0-.144-.716l-.882-.51Z" /></g></svg>);
const DonutChart = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DonutChartBase} {...rest} ref={ref} />);
export default DonutChart;